export default [
	{
		path: "/pros/reviews",
		exact: true,
		policy: "providerAuth",
		component: "Reviews/Reviews",
		mui: true,
	},
];
